import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { cancelAsn, createAsn, fetchAsns } from '../../api/ans';
import resetStore from '../resetStore';

export const createAsnThunk = createAsyncThunk(
  'asns/createAsn',
  async (asnData, { rejectWithValue }) => {
    try {
      const result = await createAsn(asnData);
      return result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message || 'Ошибка создания ASN'
      );
    }
  }
);

export const fetchAsnsThunk = createAsyncThunk(
  'asns/fetchAsns',
  async (paramsArg, { rejectWithValue }) => {
    const params = paramsArg || {};
    try {
      const result = await fetchAsns(params);
      // Ожидаем, что ответ — объект с полем asns (массив)
      return result.asns || [];
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message || 'Ошибка загрузки ASN'
      );
    }
  }
);

export const cancelAsnThunk = createAsyncThunk(
  'asns/cancelAsn',
  async (data, { rejectWithValue }) => {
    try {
      const result = await cancelAsn(data);
      return result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message || 'Ошибка отмены ASN'
      );
    }
  }
);

export const updateAsnThunk = createAsyncThunk(
  'asns/updateAsn',
  async ({ asnData, asnNo }, { rejectWithValue }) => {
    console.log(asnData, asnNo, 'fromUpdateAsnThunk');
    try {
      const result = await createAsn({ ...asnData, asn_no: asnNo });
      return result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message || 'Ошибка обновления ASN'
      );
    }
  }
);

const initialState = {
  asns: [],
  selectedAsns: [],
  createStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  createError: null,
  fetchStatus: 'idle',
  fetchError: null,
  cancelStatus: 'idle',
  cancelError: null,
  updateStatus: 'idle',
  updateError: null,
};

const asnsSlice = createSlice({
  name: 'asn',
  initialState,
  reducers: {
    setAsns(state, action) {
      state.asns = action.payload;
    },
    toggleSelected(state, action) {
      const id = action.payload;
      if (state.selectedAsns.includes(id)) {
        state.selectedAsns = state.selectedAsns.filter((asnId) => asnId !== id);
      } else {
        state.selectedAsns.push(id);
      }
    },
    clearSelected(state) {
      state.selectedAsns = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAsnThunk.pending, (state) => {
        state.createStatus = 'loading';
        state.createError = null;
      })
      .addCase(createAsnThunk.fulfilled, (state) => {
        state.createStatus = 'succeeded';
      })
      .addCase(createAsnThunk.rejected, (state, action) => {
        state.createStatus = 'failed';
        state.createError = action.payload;
      })
      .addCase(fetchAsnsThunk.pending, (state) => {
        state.fetchStatus = 'loading';
        state.fetchError = null;
      })
      .addCase(fetchAsnsThunk.fulfilled, (state, action) => {
        state.fetchStatus = 'succeeded';
        state.asns = action.payload;
      })
      .addCase(fetchAsnsThunk.rejected, (state, action) => {
        state.fetchStatus = 'failed';
        state.fetchError = action.payload;
      })
      .addCase(cancelAsnThunk.pending, (state) => {
        state.cancelStatus = 'loading';
        state.cancelError = null;
      })
      .addCase(cancelAsnThunk.fulfilled, (state) => {
        state.cancelStatus = 'succeeded';
      })
      .addCase(cancelAsnThunk.rejected, (state, action) => {
        state.cancelStatus = 'failed';
        state.cancelError = action.payload;
      })
      .addCase(updateAsnThunk.pending, (state) => {
        state.updateStatus = 'loading';
        state.updateError = null;
      })
      .addCase(updateAsnThunk.fulfilled, (state) => {
        state.updateStatus = 'succeeded';
      })
      .addCase(updateAsnThunk.rejected, (state, action) => {
        state.updateStatus = 'failed';
        state.updateError = action.payload;
      })
      .addCase(resetStore, () => initialState);
  },
});

export const { setAsns, toggleSelected, clearSelected } = asnsSlice.actions;
export default asnsSlice.reducer;
